export const ROLES = {
  super_user: 'SUPER_USER',
  owner: 'OWNER',
  administrator: 'ADMINISTRATOR',
  user: 'USER',
  viewer: 'VIEWER',
  applier: 'APPLIER',
  reporter: 'REPORTER',
  unset: 'NOT_SET',
} as const;

export const isUnassignedRole = (value: string): boolean =>
  value === 'UNSET' || value === 'NOT_SET';

export const SCOPES = {
  canCreate: 'can-create',
  canEdit: 'can-edit',
  canDelete: 'can-delete',
  canView: 'can-view',
} as const;

export const ADMINISTRATORS = {
  owner: ROLES.owner,
  administrator: ROLES.administrator,
} as const;

export const USERS: { [index: string]: string } = {
  super_user: ROLES.super_user,
  owner: ROLES.owner,
  administrator: ROLES.administrator,
  user: ROLES.user,
  viewer: ROLES.viewer,
} as const;

export const USERS_ROLES: string[] = Object.values(USERS).map(value => value);
